import {
	DrawingController,
    AnnotationGeometryToSVGProxy,
    DBxEvent,
    DataQuery
} from "cartovista";
import {show} from "../appTools/Alerts";
import {compactGeometry} from "../utils/CvUtils";
import {addLines, addAnnotations, updateLines, updateAnnotations, deleteLines, deleteAnnotations} from "../utils/ServerRequests";

    //update new feature SCENARIO value on creation
    var commitNewFeatureToDrawingLayer = DrawingController.prototype.commitNewFeatureToDrawingLayer;
    DrawingController.prototype.commitNewFeatureToDrawingLayer = function(feature) {
        commitNewFeatureToDrawingLayer.call(this, feature);
        if ("POINT" === feature.geometryType || 0 !== feature.extent.area && 1 / 0 !== feature.extent.area) {
            var drawingLayerDataTable = this._drawingLayer.getDataTable(C.LAYERS.DRAWING_LAYER.DATATABLE_ID);
            drawingLayerDataTable.updateValue(drawingLayerDataTable.getDataColumns("SCENARIO")[0], [feature.id], this._map._scenarioId);
            //obliger de réappliquer les filtres de la themeSet en raison d'un bug cartoVista v6.2
            this._map.activeThemeSet.themeSetDataFilterSettings.unapplySettings();
            this._map.activeThemeSet.themeSetDataFilterSettings.applySettings();
            window.cartovista.dispatchEvent(new DBxEvent("DrawingControllerExtend_newDrawingFeatureCommitted", feature));
        }
    };

    //prevent changing drawing mode of a feature (for editing or deleting) before it was correctly saved on server side if not empty annotation
    var changeFeatureDrawingMode = DrawingController.prototype.changeFeatureDrawingMode;
    DrawingController.prototype.changeFeatureDrawingMode = function(feature, drawingMode) {
        if (!feature.saved && drawingMode == "LEVEL1") {
            show("DrawingControllerExtend_ChangingDrawingModeError");
        } else {
            return changeFeatureDrawingMode.call(this, feature, drawingMode);
        }
    };

    //dispatch DrawingFeaturesCommitted event after features commited
    var commitDrawingFeatures = DrawingController.prototype.commitDrawingFeatures;
    DrawingController.prototype.commitDrawingFeatures = function() {
        commitDrawingFeatures.call(this);
        window.cartovista.dispatchEvent(new DBxEvent("DrawingControllerExtend_DrawingFeaturesCommitted"));
    };

    //dispatch DrawingFeaturesCommitted when annotations LEVEL2 (text changing) mode finished
    var onDocMouseDown = AnnotationGeometryToSVGProxy.prototype._onDocMouseDown;
    AnnotationGeometryToSVGProxy.prototype._onDocMouseDown = function(evt) {
        onDocMouseDown.call(this, evt);
        if (this._drawingMode == "NONE") {
            window.cartovista.dispatchEvent(new DBxEvent("DrawingControllerExtend_DrawingFeaturesCommitted"));
        }
    };

    export default class DrawingControllerExtend {
        constructor(){
            window.cartovista.addOneTimeEventListener("ServerDataInitialized", this._onServerDataInitialized, this);
            window.cartovista.addEventListener("DrawingControllerExtend_newDrawingFeatureCommitted", this._onNewDrawingFeatureCommitted, this);
            window.cartovista.addEventListener("DrawingControllerExtend_DrawingFeaturesCommitted", this._onDrawingFeaturesCommitted, this);
            window.cartovista.addEventListener("ReloadDataTool_ReloadStarted", this._onReloadDataStarted, this);
            window.cartovista.addEventListener("ReloadDataTool_ReloadCompleted", this._onReloadDataCompleted, this);
            this._pendingUpdatedFeatures = [];
            this._pendingDeletedFeatures = [];
        }

    _onServerDataInitialized(evt) {
        new Promise(function(resolve, reject) {
            if (!window.cartovista.getMap(C.MAP.ID)) {
                window.cartovista.addOneTimeEventListener(cartovista.EVENTS.MAP_LOADED + "_" + C.MAP.ID, resolve, this);
            } else {
                resolve();
            }
        }).then(function() {
            this._map = window.cartovista.getMap(C.MAP.ID);
            this._mapController = window.cartovista.getMapController(this._map);
            this._$drawingToolBtn = $(".cv-drawingTool");
            this._$selectionToolBtn = $(".cv-selectDrawingTool");
            this._$drawAnnotationToolBtn = $(".cv-drawAnnotationTool");
            this._$drawPolylineToolBtn = $(".cv-drawPolylineTool");
            this._drawingController = this._mapController._drawingController;
            this._drawingController._drawingLayer = this._map.getLayer(C.LAYERS.DRAWING_LAYER.LAYER_ID);
            this._drawingLayer = this._drawingController.drawingLayer;
            this._drawingLayerDataTable = this._drawingLayer.getDataTable(C.LAYERS.DRAWING_LAYER.DATATABLE_ID);
            this._drawingLayer.attributesDataTable = this._drawingLayerDataTable; //important to define (used by CV)
            //this._drawingLayer.addEventListener(this._drawingLayer.EVENTS.FEATURES_ADDED, this._onNewDrawingFeatureCommitted, this);
            this._drawingLayer.addEventListener(this._drawingLayer.EVENTS.FEATURES_REMOVED, this._onDrawingDeleted, this);
            this._drawingLayer.addEventListener(this._drawingLayer.EVENTS.FEATURES_REMOVED, _.debounce(this._onDrawingDeletedDebounced.bind(this), 5));
            this._drawingController.addEventListener(this._drawingController.EVENTS.FEATURE_CHANGE_ENDED, this._onDrawingFeatureChanged, this);
            var descColumn = this._drawingLayerDataTable.getDataColumns("Description")[0];
            descColumn.addEventListener(descColumn.EVENTS.VALUES_UPDATED, this._onDrawingFeatureChanged, this);
            this._toggleInputsDisabledProperty(C.APP_TOOLS.AUTH_SESSION.USER.EDITION_ALLOWED ? false : true);
            this._prepareDrawingFeatures();
            window.cartovista.addEventListener("AuthSession_UserLoggedOut", this._onAuthSessionUserLoggedOut, this);
        }.bind(this));
    };

    _onAuthSessionUserLoggedOut(evt) {
        this._toggleInputsDisabledProperty(true);
    };

    _toggleInputsDisabledProperty(disabled) {
        if (disabled) {
            this._$drawingToolBtn.prop("disabled", true).addClass("k-state-disabled");
            this._$selectionToolBtn.prop("disabled", true).addClass("k-state-disabled");
            this._$drawAnnotationToolBtn.prop("disabled", true).addClass("k-state-disabled");
            this._$drawPolylineToolBtn.prop("disabled", true).addClass("k-state-disabled");
        } else {
            this._$drawingToolBtn.prop("disabled", "").removeClass("k-state-disabled");
            this._$selectionToolBtn.prop("disabled", "").removeClass("k-state-disabled");
            this._$drawAnnotationToolBtn.prop("disabled", "").removeClass("k-state-disabled");
            this._$drawPolylineToolBtn.prop("disabled", "").removeClass("k-state-disabled");
        }
    };

    _onReloadDataStarted(evt) {
        //this._drawingLayer.removeEventListener(this._drawingLayer.EVENTS.FEATURES_ADDED, this._onNewDrawingFeatureCommitted, this);
        this._drawingLayer.removeEventListener(this._drawingLayer.EVENTS.FEATURES_REMOVED, this._onDrawingDeleted, this);
        this._drawingLayer.removeEventListener(this._drawingLayer.EVENTS.FEATURES_REMOVED, _.debounce(this._onDrawingDeletedDebounced.bind(this), 5));
        this._toggleInputsDisabledProperty(true);
    };

    _onReloadDataCompleted(evt) {
        //this._drawingLayer.addEventListener(this._drawingLayer.EVENTS.FEATURES_ADDED, this._onNewDrawingFeatureCommitted, this);
        this._drawingLayer.addEventListener(this._drawingLayer.EVENTS.FEATURES_REMOVED, this._onDrawingDeleted, this);
        this._drawingLayer.addEventListener(this._drawingLayer.EVENTS.FEATURES_REMOVED, _.debounce(this._onDrawingDeletedDebounced.bind(this), 5));
        this._toggleInputsDisabledProperty(C.APP_TOOLS.AUTH_SESSION.USER.EDITION_ALLOWED ? false : true);
        this._prepareDrawingFeatures();
    };

    _onActiveThemeSetChanged(evt) {
        //ensure no feature stays in edition mode while changing themeSet
        this._drawingController.commitDrawingFeatures();
    };

    _prepareDrawingFeatures() {
        this._drawingLayer.getFeatures(null, function(result) {
            _.forEach(result.features, function(feature) {
                feature.guid = feature.id;
                feature.saved = true;
                feature.style.addEventListener(feature.style.EVENTS.CONTENT_CHANGED, this._onDrawingFeatureChanged, this);
            }.bind(this));
        }, this, false);
    };

    _onDrawingFeatureChanged(evt) {
        switch (evt.eventType) {
            case "DrawingControllerFeatureChangeEnded":
                //filter features that are saved to prevent updating new empty annotation
                this._pendingUpdatedFeatures = _.unionBy(this._pendingUpdatedFeatures, _.filter(evt.features, "saved"), "id");
                break;
            case "dataColumnValueUpdated":
            case "styleContentChanged":
                //filter features that are saved to prevent updating new empty annotation
                this._pendingUpdatedFeatures = _.unionBy(this._pendingUpdatedFeatures, _.filter(this._drawingLayer._drawingFeatures, "saved"), "id");
                break;
            default:
                throw new Error("DrawingControllerExtend._onDrawingFeatureChanged() - evt.eventType : " + evt.eventType + " is invalid.");
        }
    };

    _onDrawingFeaturesCommitted(evt) {
        if (this._pendingUpdatedFeatures.length) {
            var pendingGroups = _.groupBy(this._pendingUpdatedFeatures, "geometryType");
            if (typeof pendingGroups["POLYLINE"] != "undefined") {
                this._updateLines(pendingGroups["POLYLINE"]);
            }
            if (typeof pendingGroups["ANNOTATION"] != "undefined") {
                this._updateAnnotations(pendingGroups["ANNOTATION"]);
            }
            this._pendingUpdatedFeatures = [];
        }
    };

    _onNewDrawingFeatureCommitted(evt) {
        var feature = evt.source;
        if (!feature.saved) {
            switch (feature.geometryType) {
                case "POLYLINE":
                    this._addLines([feature]);
                    break;
                case "ANNOTATION":
                    //do not save empty annotation, add one time listener of geometry content changed
                    feature.addOneTimeEventListener(feature.EVENTS.FEATURE_GEOMETRY_CONTENT_CHANGED, this._onAnnotationTextAdded, this);
                    break;
                default:
                    throw new Error("DrawingControllerExtend._onNewDrawingFeatureCommitted() - feature.geometryType : " + feature.geometryType + " is invalid.");
            }
        } else {
            throw new Error("DrawingControllerExtend._onNewDrawingFeatureCommitted() - feature.saved is true.");
        }
    };

    //save the annotation partialFeature after the text was added
    _onAnnotationTextAdded(evt) {
        this._drawingController.partialLayer.getFeatures([evt.source.id], function(result) {
            if (result.features.length) {
                evt.source.currentGeometry.text = result.features[0].currentGeometry.text;
                this._addAnnotations([evt.source]);
            }
        }, this);
    };

    _onDrawingDeleted(evt) {
        this._pendingDeletedFeatures = _.unionBy(this._pendingDeletedFeatures, _.filter(evt.features, "saved"), "id");
    };

    _onDrawingDeletedDebounced() {
        var pendingGroups = _.groupBy(this._pendingDeletedFeatures, "geometryType");
        if (typeof pendingGroups["POLYLINE"] != "undefined") {
            this._deleteLines(pendingGroups["POLYLINE"]);
        }
        if (typeof pendingGroups["ANNOTATION"] != "undefined") {
            this._deleteAnnotations(pendingGroups["ANNOTATION"]);
        }
        this._pendingDeletedFeatures = [];
    };

    _getFeaturesData(features) {
        return _.map(features, function(feature) {
            switch (feature.geometryType) {
                case "POLYLINE" :
                    return {
                        "attributes" : this._getPolylineAttributes(feature),
                        "geometry" : compactGeometry(feature.currentGeometry)
                    };
                    break;
                case "ANNOTATION" :
                    return {
                        "attributes" : this._getAnnotationAttributes(feature),
                        "geometry" : compactGeometry(feature.currentGeometry)
                    };
                    break;
                default:
                    throw new Error("DrawingControllerExtend._getFeaturesData() - feature.geometryType : " + feature.geometryType + " is invalid.");
            }
        }.bind(this));
    };

    _getPolylineAttributes(feature) {
        var attributes;
        var query = new DataQuery(this._drawingLayerDataTable.getDataColumns(["Description", "SCENARIO"]), [feature.id]);
        query.useDataFilters = false;
        query.execute(function(result) {
            attributes = {
                "GUID" : feature.guid,
                "DESCRIPTION" : result.values[this._drawingLayerDataTable.id]["Description"][0],
                "SCENARIO" : result.values[this._drawingLayerDataTable.id]["SCENARIO"][0],
                "STROKE_STYLE" : feature.style.symbolizers[0].strokeStyle,
                "STROKE_COLOR" : feature.style.symbolizers[0].strokeColor.rgba,
                "STROKE_PATTERN" : feature.style.symbolizers[0].strokePattern,
                "STROKE_WIDTH" : feature.style.symbolizers[0].strokeWidth
            };
        }, this);
        return attributes;
    };

    _getAnnotationAttributes(feature) {
        var attributes;
        var query =  new DataQuery(this._drawingLayerDataTable.getDataColumns(["Description", "SCENARIO"]), [feature.id]);
        query.useDataFilters = false;
        query.execute(function(result) {
                attributes = {
                    "GUID" : feature.guid,
                    "DESCRIPTION" : result.values[this._drawingLayerDataTable.id]["Description"][0],
                    "SCENARIO" : result.values[this._drawingLayerDataTable.id]["SCENARIO"][0],
                    "ANCHOR_X" : feature.currentGeometry.anchorCoordinates[0],
                    "ANCHOR_Y" : feature.currentGeometry.anchorCoordinates[1],
                    "TEXT_POSITION_X" : feature.currentGeometry.textPositionCoordinates[0],
                    "TEXT_POSITION_Y" : feature.currentGeometry.textPositionCoordinates[1],
                    "MAP_SCALE" : feature.currentGeometry.mapScale,
                    "ROTATION" : feature.currentGeometry.rotation,
                    //remplace les \n par <br> en raison du bug esri arcpy.SetParameter
                    "TEXT" : feature.currentGeometry.text.replace(/\n/g, "<br>"),
                    "TEXT_COLOR" : feature.style.symbolizers[0].color.rgba,
                    "TEXT_SIZE" : feature.style.symbolizers[0].size,
                    "BOLD" : feature.style.symbolizers[0].bold ? 1 : 0,
                    "ITALIC" : feature.style.symbolizers[0].italic ? 1 : 0,
                    "UNDERLINED" : feature.style.symbolizers[0].underlined ? 1 : 0,
                    "HAS_HALO" : feature.style.symbolizers[0].hasHalo ? 1 : 0,
                    "HALO_COLOR" : feature.style.symbolizers[0].haloColor.rgba,
                    "FILL_STYLE" : feature.style.symbolizers[0].fillStyle,
                    "FILL_COLOR" : feature.style.symbolizers[0].fillColor1.rgba,
                    "STROKE_STYLE" : feature.style.symbolizers[0].strokeStyle,
                    "STROKE_COLOR" : feature.style.symbolizers[0].strokeColor.rgba,
                    "STROKE_WIDTH" : feature.style.symbolizers[0].strokeWidth
                };
            }, this);
        return attributes;
    };

    _getFeatureQueryExpression(features) {
        return {
            "LOGICAL_OPERATOR" : null,
            "QUERIES" : [
                {"FIELD" : "GUID", "OPERATOR" : (features.length > 1 ? "IN" : "="), "VALUE" : (features.length > 1 ? _.map(features, "guid") : features[0].guid)},
            ]
        };
    };

    _addLines(features) {
        addLines(this._getFeaturesData(features))
            .then(function(guids) {
                _.forEach(features, function(feature, idx) {
                    feature.guid = guids[idx];
                    feature.saved = true;
                    feature.style.addEventListener(feature.style.EVENTS.CONTENT_CHANGED, this._onDrawingFeatureChanged, this);
                }.bind(this));
                show(features.length > 1 ? "DrawingControllerExtend_LinesSaved" : "DrawingControllerExtend_LineSaved", {"count": features.length});
            }.bind(this));
    };

    _addAnnotations(features) {
        addAnnotations(this._getFeaturesData(features))
            .then(function(guids) {
                _.forEach(features, function(feature, idx) {
                    feature.guid = guids[idx];
                    feature.saved = true;
                    feature.style.addEventListener(feature.style.EVENTS.CONTENT_CHANGED, this._onDrawingFeatureChanged, this);
                }.bind(this));
                show(features.length > 1 ? "DrawingControllerExtend_AnnotationsSaved" : "DrawingControllerExtend_AnnotationSaved", {"count": features.length});
            }.bind(this));
    };

    _updateLines(features) {
        updateLines(this._getFeatureQueryExpression(features), this._getFeaturesData(features))
            .then(function(response) {
                show(features.length > 1 ? "DrawingControllerExtend_LinesSaved" : "DrawingControllerExtend_LineSaved", {"count": features.length});
            });
    };

    _updateAnnotations(features) {
        updateAnnotations(this._getFeatureQueryExpression(features), this._getFeaturesData(features))
            .then(function(response) {
                show(features.length > 1 ? "DrawingControllerExtend_AnnotationsSaved" : "DrawingControllerExtend_AnnotationSaved", {"count": features.length});
            });
    };

    _deleteLines(features) {
        deleteLines(this._getFeatureQueryExpression(features))
            .then(function(response) {
                show(features.length > 1 ? "DrawingControllerExtend_LinesDeleted" : "DrawingControllerExtend_LineDeleted", {"count": features.length});
            });
    };

    _deleteAnnotations(features) {
        deleteAnnotations(this._getFeatureQueryExpression(features))
            .then(function(response) {
                show(features.length > 1 ? "DrawingControllerExtend_AnnotationsDeleted" : "DrawingControllerExtend_AnnotationDeleted", {"count": features.length});
            });
    };

}
